import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    expired: {
        id: "warning.refreshAndReload",
    },
    unauthorized: {
        id: "warning.unauthorized",
    },
    reload: {
        id: "warning.reloadButton",
    },
    browserversion: {
        id: "supportError.browserversion",
    },
    osversion: {
        id: "supportError.osversion",
    },
    browser: {
        id: "supportError.browser",
    },
});

export default messages;
